import { z } from 'zod';

/**
 * Terms and Conditions Schema (factory)
 *
 * - termsStatutory: required iff visible (FORM and/or VVI link present in BA response)
 * - termsContractual: always required (GTC + Stornobedingungen + optional insurance)
 * - privacyPolicy: always required
 * - newsletterOptIn: optional opt-in
 *
 * Pass `showStatutory` from `checkout.isStatutoryCheckboxVisible`.
 */
export function createTermsFormSchema(showStatutory: boolean) {
  return z.object({
    termsStatutory: showStatutory
      ? z.boolean().refine((val) => val === true, {
          message: 'ibe.validation.terms.statutory.required',
        })
      : z.boolean().optional(),
    termsContractual: z.boolean().refine((val) => val === true, {
      message: 'ibe.validation.terms.contractual.required',
    }),
    privacyPolicy: z.boolean().refine((val) => val === true, {
      message: 'ibe.validation.terms.privacy-policy.required',
    }),
    newsletterOptIn: z.boolean().optional(),
  });
}

export type TermsFormValues = z.infer<ReturnType<typeof createTermsFormSchema>>;
